export default {"src":"/_next/static/media/safepoints_16.2caaf99e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};